const SectionTeambuilding = Class(
	/**
	 * @lends {SectionTeambuilding#}
	 */
	{
		__NAME: 'SectionTeambuilding',

		background: null,
		bodyClass: 'small-nav',
		menuItem: 'teambuilding',

		draw: function() {
			this._mGetEvents = new DR.events.GetEventsList();
			this._mGetEvents.type = DR.events.GetEventsList.TYPE_ONLINE_WEB;
			this._mGetEvents.select = [
				new DR.events.select.Event().id().title().image().showResults().region().startTime().endTime().seoTitle()
					.description().hasImage().status().settings().stats().userRating().isNewGame(),
				new DR.roadgames.select.Image().original().medium()
			];
			this._mGetEvents.onLoad = this._mGetEventsRe;
			this.apiCall.addMethod(this._mGetEvents);

			this._caseStudies = new T.CaseStudies('team_building', this.apiCall)

			this.apiCall.call();
		},

		_mGetEventsRe: function() {
			let heroUrl = {
				tag: 'a',
				href: D.url(D.Lang.get('teambuilding.welcome.button.link')),
				className: 'button button-large button-pink',
				text: D.Lang.get('teambuilding.welcome.button')
			};
			if (D.Lang.get('teambuilding.welcome.button.link') === 'contact-us') {
				delete heroUrl.href;
				heroUrl.onclick = function() {
					D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
				};
			}

			new T.Hero({
				backgroundClass: `background-picture-teambuilding${D.LANG !== 'lv' ? '-en' : ''}`,
				backgroundOverlay: true,
				backgroundArrow: true,
				backgroundMask: 'white',
				title: D.Lang.get('teambuilding.welcome.title'),
				text: D.Lang.get('teambuilding.welcome.text'),
				button: mkE(heroUrl)
			}).append(this.layout.ct());

			if (this._mGetEvents.re.events.length) {
				let els = [];
				for (let i = 0; i < this._mGetEvents.re.events.length; i++ ) {
					const listItem = this._mGetEvents.re.events[i];
					els.push(new T.ListEvent(listItem.event, true));
				}
				if (els.length > 0) {
					mkE({
						tag: 'div',
						className: 'events-list container',
						els: [
							{
								tag: 'h3',
								text: D.Lang.get('teambuilding.games')
							},
							this._slider = new T.Glider(new T.Glider.Par().setContent(els))
						]
					}).append(this.layout.ct());
				}
			}

			mkE({
				tag: 'div',
				className: 'case-studies-wrapper',
				els: [
					this._caseStudies
				]
			}).append(this.layout.ct());

			this._testimonials = T.Quotes.get('online');
			if (this._testimonials) {
				mkE({
					tag: 'div',
					className: 'testimonials-wrapper',
					els: [
						this._testimonials
					]
				}).append(this.layout.ct());
			}

			mkE({
				tag: 'div',
				className: 'game-setup-wrapper',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get('teambuilding.game-setup.title')
							}
						]
					},
					this._gameSetup = new T.GameSetup('teambuilding', 'setup')
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'easy-access-wrapper',
				els: [
					new T.EasyAccess()
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'how-to-wrapper',
				els: [
					this._howTo = new T.HowTo([
						'matchmaker',
						'explorer',
						'groupie',
						'expert',
						'detective'
					], 'matchmaker', true, null, null, true)
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'corporate-form-wrapper',
				els: [
					new T.CorporateContactUs({
						type: 'teambuilding'
					})
				]
			}).append(this.layout.ct());
		},

		onShow() {
			if (this._caseStudies) {
				this._caseStudies.onShow();
			}
			if (this._testimonials) {
				this._testimonials.onShow();
			}
			if (this._gameSetup) {
				this._gameSetup.onShow();
			}
			if (this._slider) {
				this._slider.onShow();
			}
			if (this._howTo) {
				this._howTo.onShow();
			}
		},

		onLeave() {
			if (this._caseStudies) {
				this._caseStudies.onLeave();
			}
			if (this._testimonials) {
				this._testimonials.onLeave();
			}
			if (this._gameSetup) {
				this._gameSetup.onLeave();
			}
			if (this._slider) {
				this._slider.onLeave();
			}
			if (this._howTo) {
				this._howTo.onLeave();
			}
		}
	},
	Section
);